var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotFoundIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#dde5e8;}.cls-2{fill:#9bbdc6;}.cls-3{fill:#afc3c9;}.cls-4{fill:#e04848;}.cls-5{fill:#9e2d2d;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "document-denied-flat") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M422.4,153.6V448a64,64,0,0,1-64,64H76.8a64,64,0,0,1-64-64V64a64,64,0,0,1,64-64H268.93Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M422.4,153.6H332.8a64,64,0,0,1-64-64V0h.13Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M217.6,256a12.8,12.8,0,0,1-12.8,12.8H128A12.8,12.8,0,0,1,115.2,256h0A12.8,12.8,0,0,1,128,243.2h76.8A12.8,12.8,0,0,1,217.6,256Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M294.4,307.2A12.8,12.8,0,0,1,281.6,320H128a12.8,12.8,0,0,1-12.8-12.8h0A12.8,12.8,0,0,1,128,294.4H281.6a12.8,12.8,0,0,1,12.8,12.8Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M294,358.4a12.8,12.8,0,0,1-12.8,12.8H128a12.8,12.8,0,0,1-12.8-12.8h0A12.8,12.8,0,0,1,128,345.6H281.22A12.8,12.8,0,0,1,294,358.4Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M499.2,422.4a89.62,89.62,0,0,1-143.3,71.74,92.74,92.74,0,0,1-18-18A89.62,89.62,0,0,1,463.3,350.66a92.72,92.72,0,0,1,18,18A89.31,89.31,0,0,1,499.2,422.4Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M481.34,368.7,355.9,494.14a92.74,92.74,0,0,1-18-18L463.3,350.66A92.72,92.72,0,0,1,481.34,368.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundIcon);
export default __webpack_public_path__ + "static/media/not-found-icon.6b54b0c45b2332ddb93c697e6877ea9e.svg";
export { ForwardRef as ReactComponent };